import React from 'react'
import PropTypes from 'prop-types'
import 'moment/locale/pt-br' // without this line it didn't work
import { graphql } from 'gatsby'
import styled from 'styled-components'
import decodeEntities from '../util/textDecode'
import { device } from './Breakpoints'
import { colors } from './Colors'
import imgCurso from '../img/alto-risco.png'

const Container = styled.section`
  width: 100%;
  .center {
    max-width: 1114px;
    margin: auto;
    @media ${device.mobileL} {
      max-width: 100%;
      text-align: center;
    }
    h2 {
      text-align: left;
      margin-top: 1em;
      margin-bottom: 0.4em;

      @media ${device.mobileL} {
        text-align: center;
      }
    }
  }
  h2 {
    margin-top: 2em;
    text-align: center;
    color: ${colors.verde};
    font-size: 1.2em;
  }
  ul.materiais {
    padding: 0;
    margin: 2em 0 0;
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    @media ${device.mobileL} {
      margin: 2em;
    }
    li {
      list-style: none;
      padding: 0;
      background: #fff;
      border: 1px solid #ebebea;
      margin-bottom: 2em;
      width: 33.33%;
      box-sizing: border-box;
      padding: 2em;
      justify-content: space-between;
      display: flex;
      flex-wrap: wrap;
      align-content: flex-start;
      @media ${device.mobileL} {
        width: 100%;
      }
      .thumb {
        margin: -2em -2em 1.5em;
        overflow: hidden;
        img {
          width: 100%;
        }
      }
      small {
        font-size: 0.6em;
        padding: 0.5em 0;
      }
      h3 {
        margin: 0.6em 0;
        display: block;
        width: 100%;
        font-size: 1em;
        a {
          color: ${colors.verde};
          text-decoration: none;
          display: block;
        }
      }
      p {
        font-size: 0.6em;
      }
    }
  }
  ul.tipo {
    margin: 0;
    padding: 0;
    display: flex;
    justify-content: space-between;
    li {
      margin-right: 0.5em;
      border: 0;
      padding: 0.5em 0.8em;
      border-radius: 5px;
      width: auto;
      color: #ffffff;
      font-size: 0.6em;
      background: ${colors.lilas};
    }
  }
  ul.ebook {
    li {
      background: ${colors.verde};
    }
  }
`

const MateriaisPage = ({ materiais }) => {
  return (
    <Container>
      <div className="center">
        <h2>Materiais educativos</h2>
        <ul className="materiais">
          {materiais.map(({ node: material }) => (
            <li key={material.id}>
              <a
                href={material.materiaisEducativos.link}
                target="_blank"
                rel="noreferrer"
                className="thumb"
              >
                <img
                  src={
                    material.materiaisEducativos.imagemDestaque !== null
                      ? material.materiaisEducativos.imagemDestaque.sourceUrl
                      : imgCurso
                  }
                  alt="Curso"
                />
              </a>
              <ul
                className={
                  material.materiaisEducativos.tipo === 'Ebook'
                    ? 'tipo ebook'
                    : 'tipo'
                }
              >
                <li>{material.materiaisEducativos.tipo}</li>
              </ul>
              <small>{material.materiaisEducativos.data}</small>
              <h3>
                <a
                  href={material.materiaisEducativos.link}
                  target="_blank"
                  rel="noreferrer"
                >
                  {decodeEntities(material.title)}
                </a>
              </h3>
              <div
                dangerouslySetInnerHTML={{
                  __html: material.excerpt.replace(/<p class="link-more.*/, ''),
                }}
              />
            </li>
          ))}
        </ul>
      </div>
    </Container>
  )
}

MateriaisPage.propTypes = {
  materiais: PropTypes.arrayOf(PropTypes.object),
}

export const MateriaisQuery = graphql`
  fragment MateriaisListFields on wordpress__wp_materiais {
    id
    title
    date
    slug
    excerpt
    materiaisEducativos {
      data
      link
      tipo
      imagemDestaque {
        sourceUrl
      }
    }
  }
`
export default MateriaisPage
